<template>
  <div>
    <button
        type="submit"
        id="submitbutton"
        class="btn btn-primary btn-sm submitbutton btn-filled-blue w-100"
        @click="executarRecaptcha"
        :disabled="disabled"
    >
        <p class="button-body">{{ buttontext }}</p>
    </button>
  </div>
</template>

<script setup>
import { useReCaptcha } from "vue-recaptcha-v3";
import axios from "axios";

const props = defineProps({
  senddata: Function,
  csrftolkien: String,
  buttontext: String,
  recaptchurl: String,
  existemptyvalue: Function,
  disabled: Boolean
})

const emit = defineEmits(['response'])

const { executeRecaptcha, recaptchaLoaded  } = useReCaptcha();

async function executarRecaptcha(el) {
  try {

    el.preventDefault();

    //Check by Empty Values
    if(props.existemptyvalue()){

        emit('response', false);

        return;

    }
    
    //await recaptchaLoaded();

    // Gera token do Google
    const token = await executeRecaptcha("website_form");

    // Envia para o backend Laravel
    const response = await axios.post(props.recaptchurl, 
      {
        recaptchatoken: token
      },
      {
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": props.csrftolkien,
            "Access-Control-Allow-Origin": window.location.origin
        }
      }
    );

    //Send Contact Data
    if(response.data.success){

        emit('response', true);

        return props.senddata();

    }

    emit('response', false);
    
    return;

  } catch (error) {
    
    throw new Error(error);

  }
}
</script>
